import React from "react";
import { Home, X, Download } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ImageViewerProps {
    fileUrl: string;
    fileName: string;
    onClose: () => void;
}

export const ImageViewer = ({ fileUrl, fileName, onClose }: ImageViewerProps) => {
    return (
        <div className="flex flex-col h-full bg-[#f3f4f6]">
            {/* Top Navigation Bar */}
            <div className="h-10 bg-white border-b flex items-center px-4 text-xs text-blue-600">
                <Button variant="ghost" size="sm" className="h-6 w-6 p-0 mr-2" onClick={onClose}>
                    <Home className="h-4 w-4 text-gray-400" />
                </Button>
                <span className="text-gray-400 mx-2">/</span>
                <span className="cursor-pointer hover:underline" onClick={onClose}>Archivos</span>
                <span className="text-gray-400 mx-2">/</span>
                <span className="font-semibold text-gray-700">{fileName}</span>
                <div className="flex-1"></div>
                <Button variant="ghost" size="sm" className="h-7 w-7 p-0 ml-2" onClick={onClose}>
                    <X className="h-4 w-4 text-gray-400" />
                </Button>
            </div>

            {/* Image Viewer Container */}
            <div className="flex-1 bg-gray-900 p-4 flex items-center justify-center overflow-auto">
                <img 
                    src={fileUrl} 
                    className="max-w-full max-h-[80vh] shadow-2xl rounded-lg border border-gray-800 object-contain bg-slate-950"
                    alt={fileName}
                />
            </div>
        </div>
    );
};
